// extracted by mini-css-extract-plugin
module.exports = {"noSet":"NoSet_style_noSet__E0zwG","tip":"NoSet_style_tip__1sQHj","btn":"NoSet_style_btn__3n8xO","img":"NoSet_style_img__3ZjcL"};